import { FC, useState } from 'react';
import {
  InterventionReportDetailsProps,
  InterventionReportsKebabOption,
} from './interventionReports.type';
import ReportDetails from '../../component/reportDetails/reportDetails';
import { createInterventionReportConfig } from '../../component/reportDetails/interventionReportConfig';
import { getInterventionReportsKebabOptions } from './interventionReportsHelper';
import { ReportDetailsConfig } from '../../component/reportDetails/reportDetails.types';
import { HarmReportDetails } from '../harmReports/harmReportDetails';
import {
  HarmReport,
  GetReportsByFilterRequest,
  ReportStatus,
} from '@inplay/models';
import { reportService } from '../../service/instances';
import { useOrganizationContext } from '../../service/context/organizationContext';
import ModalComponent from '../../component/modal/modal';
import Loading from '../../assets/loading/loading';
import { getInterventionReportEditPermissions } from '../../utils/interventionReportEditPermissions';
import { useUserDetailContext } from '../../service/context/userDetailContext';
export const InterventionReportDetails: FC<InterventionReportDetailsProps> = (
  props,
) => {
  const config: ReportDetailsConfig = createInterventionReportConfig(
    props.interventionReport.raw,
  );
  const { selectedVenueBranch } = useOrganizationContext();
  const { userDetail } = useUserDetailContext();
  const [viewingHarmReport, setViewingHarmReport] = useState<HarmReport | null>(
    null,
  );
  const [loadingLinkedReport, setLoadingLinkedReport] =
    useState<boolean>(false);

  const handleLinkedReportClick = async (reportId: string) => {
    if (!selectedVenueBranch) return;
    setLoadingLinkedReport(true);
    try {
      const query: GetReportsByFilterRequest = {
        venueBranchId: selectedVenueBranch._id,
        currentDate: new Date(props.interventionReport.raw.createdAt),
        status: [ReportStatus.ACTIVE],
      };
      const response = await reportService.getHarmReports(query);
      const reports: HarmReport[] = response.data?.harmReports ?? [];
      const found = reports.find(
        (r: HarmReport & { _id?: string }) =>
          r.originalReportId === reportId || r._id === reportId,
      );
      if (found) setViewingHarmReport(found);
    } catch (error) {
      console.error(
        '[InterventionReportDetails] Error fetching harm report',
        error,
      );
    } finally {
      setLoadingLinkedReport(false);
    }
  };

  return (
    <>
      <ReportDetails
        config={config}
        onClose={props.onClose}
        onReviewAndSign={props.onReviewAndSign}
        kebabOptions={getInterventionReportsKebabOptions(
          props.interventionReport.raw,
          null,
          0,
          userDetail?.type,
          getInterventionReportEditPermissions(
            props.interventionReport.raw,
            userDetail?.type,
            userDetail?.id,
          ).canEdit,
        )
          .filter((o) => o.label !== 'View')
          .map((o) => ({
            label: o.label,
            optionKey: o.label,
            loading:
              o.label === InterventionReportsKebabOption.DOWNLOAD &&
              props.downloadLoading,
          }))}
        onKebabAction={props.onKebabAction}
        onShouldCloseKebab={(action) =>
          action !== InterventionReportsKebabOption.DOWNLOAD
        }
        onLinkedReportClick={
          props.onKebabAction ? handleLinkedReportClick : undefined
        }
      />
      {loadingLinkedReport && !viewingHarmReport && (
        <ModalComponent
          onToggle={() => setLoadingLinkedReport(false)}
          open={true}
          title=""
          isShowClose
          footerHidden
          dialogClassName="w-full max-w-modal-lg h-[90vh] overflow-hidden"
        >
          <div className="flex justify-center items-center h-[calc(90vh-100px)]">
            <Loading />
          </div>
        </ModalComponent>
      )}
      {viewingHarmReport && (
        <HarmReportDetails
          harmReport={viewingHarmReport}
          closeHarmReportDetails={() => setViewingHarmReport(null)}
          handleReviewAndSignClick={() => setViewingHarmReport(null)}
        />
      )}
    </>
  );
};
